import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';
import { useAuth } from '../../lib/auth';

export default function AdminUsers() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState(''); const [role, setRole] = useState('');
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name:'', email:'', password:'', phone:'', role:'employee' });
  const [err, setErr] = useState('');

  const load = async () => {
    const params = new URLSearchParams();
    if (q) params.set('q', q); if (role) params.set('role', role);
    const { data } = await api.get('/admin/users?' + params.toString());
    setUsers(data.users || []);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const create = async (e) => {
    e.preventDefault(); setErr('');
    try { await api.post('/admin/users', form); setShow(false); setForm({ name:'',email:'',password:'',phone:'',role:'employee' }); await load(); }
    catch (e) { setErr(apiError(e)); }
  };

  const toggleActive = async (u) => {
    await api.put(`/admin/users/${u.id}`, { is_active: u.is_active ? 0 : 1 });
    await load();
  };

  const changeRole = async (u, r) => {
    try { await api.put(`/admin/users/${u.id}`, { role: r }); await load(); }
    catch (e) { alert(apiError(e)); }
  };

  const del = async (u) => {
    if (!window.confirm('Delete user?')) return;
    try { await api.delete(`/admin/users/${u.id}`); await load(); } catch (e) { alert(apiError(e)); }
  };

  return (
    <div data-testid="admin-users">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Users</h2>
        <button className="btn-ap" onClick={()=>setShow(true)} data-testid="add-user-btn">Add user</button>
      </div>
      <div className="ap-card mb-3">
        <div className="d-flex gap-2 flex-wrap">
          <input className="form-control" style={{maxWidth:260}} placeholder="Search name or email" value={q} onChange={e=>setQ(e.target.value)} data-testid="user-search" />
          <select className="form-select" style={{maxWidth:200}} value={role} onChange={e=>setRole(e.target.value)} data-testid="user-role-filter">
            <option value="">All roles</option>
            <option value="super_admin">Super Admin</option>
            <option value="admin">Admin</option>
            <option value="employee">Employee</option>
            <option value="business_owner">Business Owner</option>
            <option value="customer">Customer</option>
          </select>
          <button className="btn-ap-outline" onClick={load} data-testid="user-search-btn">Filter</button>
        </div>
      </div>
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead>
            <tr><th>ID</th><th>Name</th><th>Email</th><th>Role</th><th>Active</th><th style={{width:160}}>Actions</th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} data-testid={`user-row-${u.id}`}>
                <td>{u.id}</td>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>
                  <select className="form-select form-select-sm" value={u.role} onChange={e=>changeRole(u, e.target.value)} disabled={user?.role !== 'super_admin' && ['admin','super_admin'].includes(u.role)}>
                    <option value="super_admin">super_admin</option>
                    <option value="admin">admin</option>
                    <option value="employee">employee</option>
                    <option value="business_owner">business_owner</option>
                    <option value="customer">customer</option>
                  </select>
                </td>
                <td>{u.is_active ? 'Yes' : 'No'}</td>
                <td>
                  <button className="btn-ap-outline btn-sm me-2" onClick={()=>toggleActive(u)} data-testid={`toggle-${u.id}`}>{u.is_active ? 'Disable' : 'Enable'}</button>
                  {user?.role === 'super_admin' && <button className="btn btn-sm text-danger" onClick={()=>del(u)} data-testid={`delete-${u.id}`}>Delete</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {show && (
        <div className="position-fixed top-0 start-0 w-100 h-100" style={{ background:'rgba(0,0,0,.5)', zIndex:60 }} onClick={()=>setShow(false)}>
          <div className="ap-card mx-auto mt-5" style={{ maxWidth:480 }} onClick={e=>e.stopPropagation()}>
            <h4>Create user</h4>
            {err && <div className="alert alert-danger">{err}</div>}
            <form onSubmit={create} data-testid="create-user-form">
              <input className="form-control mb-2" placeholder="Name" required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} data-testid="cu-name"/>
              <input className="form-control mb-2" placeholder="Email" type="email" required value={form.email} onChange={e=>setForm({...form,email:e.target.value})} data-testid="cu-email"/>
              <input className="form-control mb-2" placeholder="Phone" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} data-testid="cu-phone"/>
              <input className="form-control mb-2" placeholder="Password" type="password" required value={form.password} onChange={e=>setForm({...form,password:e.target.value})} data-testid="cu-password"/>
              <select className="form-select mb-2" value={form.role} onChange={e=>setForm({...form,role:e.target.value})} data-testid="cu-role">
                {user?.role === 'super_admin' && <option value="super_admin">Super Admin</option>}
                {user?.role === 'super_admin' && <option value="admin">Admin</option>}
                <option value="employee">Employee</option>
                <option value="business_owner">Business Owner</option>
                <option value="customer">Customer</option>
              </select>
              <div className="d-flex gap-2">
                <button className="btn-ap" data-testid="cu-submit">Create</button>
                <button type="button" className="btn-ap-outline" onClick={()=>setShow(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
